import { create } from "zustand";
import {
  ModerationFlag,
  ModerationConfigResponse,
  Blocklist,
  Allowlist,
  ModerationResource,
  ModerationAction,
} from "../api/moderation";

interface ModerationState {
  flags: ModerationFlag[];
  configResponse: ModerationConfigResponse | null;
  blocklist: Blocklist | null;
  allowlist: Allowlist | null;
  loadingFlags: boolean;
  loadingConfig: boolean;
  loadingBlocklist: boolean;
  loadingAllowlist: boolean;
  error: string | null;
  loadFlags: (params?: {
    meetingId?: string;
    action?: ModerationAction;
    limit?: number;
    nextToken?: string;
  }) => Promise<void>;
  loadConfig: () => Promise<void>;
  loadBlocklist: () => Promise<void>;
  loadAllowlist: () => Promise<void>;
}

export const useModerationStore = create<ModerationState>((set) => ({
  flags: [],
  configResponse: null,
  blocklist: null,
  allowlist: null,
  loadingFlags: false,
  loadingConfig: false,
  loadingBlocklist: false,
  loadingAllowlist: false,
  error: null,

  loadFlags: async (params?) => {
    set({ loadingFlags: true, error: null });
    try {
      const response = await ModerationResource.getFlags(params);
      set({ flags: response.data, loadingFlags: false });
    } catch (err) {
      const error = err instanceof Error ? err.message : "Failed to load moderation flags";
      set({ error, loadingFlags: false });
    }
  },

  loadConfig: async () => {
    set({ loadingConfig: true, error: null });
    try {
      const response = await ModerationResource.getConfig();
      set({ configResponse: response, loadingConfig: false });
    } catch (err) {
      const error = err instanceof Error ? err.message : "Failed to load moderation config";
      set({ error, loadingConfig: false });
    }
  },

  loadBlocklist: async () => {
    set({ loadingBlocklist: true, error: null });
    try {
      const response = await ModerationResource.getBlocklist();
      set({ blocklist: response, loadingBlocklist: false });
    } catch (err) {
      const error = err instanceof Error ? err.message : "Failed to load blocklist";
      set({ error, loadingBlocklist: false });
    }
  },

  loadAllowlist: async () => {
    set({ loadingAllowlist: true, error: null });
    try {
      const response = await ModerationResource.getAllowlist();
      set({ allowlist: response, loadingAllowlist: false });
    } catch (err) {
      const error = err instanceof Error ? err.message : "Failed to load allowlist";
      set({ error, loadingAllowlist: false });
    }
  },
}));
